// extracted by mini-css-extract-plugin
export default {"actionsContainer":"templates_actionsContainer__o3BMG"};